import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import type { WorkOrderSettingsFormToModel, WorkOrderSettingsRM } from 'ab-requestModels/company/workOrderSettings.requestModel';

import * as TimeOptionUtils from '@acceligentllc/shared/utils/timeOption';

export const fromVMtoRM = (company: CompanyViewModel): WorkOrderSettingsRM => {
	return {
		dayShiftStart: TimeOptionUtils.toString(company.dayShiftStart),
		dayShiftEnd: TimeOptionUtils.toString(company.dayShiftEnd),
		nightShiftStart: TimeOptionUtils.toString(company.nightShiftStart),
		nightShiftEnd: TimeOptionUtils.toString(company.nightShiftEnd),
	};
};

export const fromFMtoRM = (form: WorkOrderSettingsRM): WorkOrderSettingsFormToModel => {
	return {
		dayShiftStart: TimeOptionUtils.toNumber(form.dayShiftStart),
		dayShiftEnd: TimeOptionUtils.toNumber(form.dayShiftEnd),
		nightShiftStart: TimeOptionUtils.toNumber(form.nightShiftStart),
		nightShiftEnd: TimeOptionUtils.toNumber(form.nightShiftEnd),
	};
};
